import { useQuery } from "@tanstack/react-query";
import { getRetailEventsMonthService, type EventsRetailMonthResponse } from "../services/getRetailEventService";

export function useGetRetailEventMonth(month: string) {
  return useQuery<EventsRetailMonthResponse, Error>({
    queryKey: ["retail-events-by-month", month],
    queryFn: () => getRetailEventsMonthService(month),
    
  });
}